import { WaitingRoomConnection } from "bouncer-waitingroom";
import { WaitingRoomHandler } from "./WaitingRoomHandler";

let wrh: WaitingRoomHandler;
let wrc = new WaitingRoomConnection();
wrc.startConnection();

async function createWaitingRoomHandler() {
    wrh = new WaitingRoomHandler(false, false, false);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createWaitingRoomHandler);
} else {
    createWaitingRoomHandler();
}
